var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoutingErrorPage from "./core/pages/RoutingErrorPage/RoutingErrorPage";
import { PATHS_VALUES, ROUTES_PATHS, } from "./shared/enums/routing-paths-values";
import ErrorPage from "./core/pages/ErrorPage/ErrorPage";
import { ClaimEnum } from "./shared/enums/claim";
import { checkPermissions } from "./shared/utils/services/permissionChecker";
import StartingPage from "./core/pages/StartingPage/StartingPage";
var defaultAuthGuard = function (claimType) {
    if (!checkPermissions(claimType)) {
        throw new Response(claimType, { status: 403 });
    }
    else {
        return new Response("", { status: 200 });
    }
};
export function builderRouting(getBasicLayout) {
    var childrenRoutes = [];
    childrenRoutes.push({
        path: "",
        loader: function () { return defaultAuthGuard(ClaimEnum.CanViewMain); },
        element: _jsx(Navigate, { to: PATHS_VALUES.DIAGRAMS_PAGE }),
    });
    childrenRoutes.push({
        path: ROUTES_PATHS.STARTING_PAGE,
        loader: function () { return defaultAuthGuard(ClaimEnum.CanViewMain); },
        Component: StartingPage,
    });
    childrenRoutes.push({
        path: ROUTES_PATHS.ERROR_PAGE,
        Component: ErrorPage,
    });
    childrenRoutes.push({
        path: ROUTES_PATHS.OBJECTS_DIAGRAMS,
        loader: function () { return defaultAuthGuard(ClaimEnum.CanViewMain); },
        lazy: function () {
            return __awaiter(this, void 0, void 0, function () {
                var DiagramsPage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, import("./modules/objects-diagrams-module/object-diagrams-module-routing")];
                        case 1:
                            DiagramsPage = (_a.sent()).DiagramsPage;
                            return [2 /*return*/, { Component: DiagramsPage }];
                    }
                });
            });
        },
    });
    childrenRoutes.push({
        path: ROUTES_PATHS.CONFIGURATION,
        loader: function () { return defaultAuthGuard(ClaimEnum.CanViewConfiguration); },
        lazy: function () {
            return __awaiter(this, void 0, void 0, function () {
                var ObjectConfigurationPage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, import("./modules/object-configuration-module/configuration-module-routing")];
                        case 1:
                            ObjectConfigurationPage = (_a.sent()).ConfigurationPage;
                            return [2 /*return*/, { Component: ObjectConfigurationPage }];
                    }
                });
            });
        },
    });
    childrenRoutes.push({
        path: ROUTES_PATHS.STATISTIC,
        loader: function () { return defaultAuthGuard(ClaimEnum.CanViewStatistic); },
        lazy: function () {
            return __awaiter(this, void 0, void 0, function () {
                var ObjectStatisticPage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, import("./modules/statistic-module/statistic-module-routing")];
                        case 1:
                            ObjectStatisticPage = (_a.sent()).StatisticPage;
                            return [2 /*return*/, { Component: ObjectStatisticPage }];
                    }
                });
            });
        },
    });
    return createBrowserRouter([
        {
            path: PATHS_VALUES.DEFAULT_PAGE,
            element: getBasicLayout(),
            children: childrenRoutes,
            errorElement: getBasicLayout(_jsx(RoutingErrorPage, {})),
        },
    ]);
}
